import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StatusPillColorsEnum } from '@shared/enums';
import { TooltipModule } from 'primeng/tooltip';
import { InfoTooltipComponent } from '../info-tooltip/info-tooltip.component';

@Component({
    selector: 'app-status-pill',
    standalone: true,
    imports: [TranslateModule, TooltipModule, InfoTooltipComponent],
    templateUrl: './status-pill.component.html',
    styleUrls: ['./status-pill.component.scss'],
})
export class StatusPillComponent {
    @Input({ required: true }) statusColor: StatusPillColorsEnum = StatusPillColorsEnum.RED;
    @Input({ required: true }) statusName: string | null = null;
    @Input({ required: false }) statusTooltip: string | null = null;
    @Input({ required: false }) size: 'large' | 'small' = 'small';
    @Input() statusPillInfo: string | null = null;

    readonly statusPillColors = StatusPillColorsEnum;

    showStatusTooltip: boolean = true;
}
